namespace advisorop.components.servicer {

    export class BillingStyleMonitorController {
        dgData: Array<any>;
        advisoryFirmId: number;
        pageLen: number;
        issuesCount: number;
        dg: DevExpress.ui.dxDataGridOptions;
        advisoryFirms: domains.IAdvisoryFirm[];
        selFirm: domains.IAdvisoryFirm;

        dgInst: DevExpress.ui.dxDataGrid;

        isInitializing: boolean = false;
        loadOptions: DevExpress.ui.dxLoadPanelOptions = {
            shadingColor: "rgba(0,0,0,0.4)",
            position: { of: "#billingStyleMonitorContent" },
            showIndicator: true,
            showPane: true,
            shading: false,
            closeOnOutsideClick: false,
            message: "Loading data...",
            bindingOptions: {
                visible: "vm.isInitializing"
            }
        }

        static $inject = ["servicerService", "generalService", "advisoryFirmApi"];
        constructor(
            private servicerService: services.ServicerService,
            private generalService: services.GeneralService,
            private advisoryFirmApi: services.AdvisoryFirmApi) {

            this.dg = {
                export: {
                    enabled: true,
                    fileName: "BillingStyleMonitor"
                },
                bindingOptions: {
                    dataSource: "vm.dgData",
                },
                scrolling: {
                    mode: "standard",
                    scrollByContent: true,
                    preloadEnabled: false,
                    useNative: false
                },
                paging: {
                    pageSize: this.pageLen,
                    enabled: true
                },
                rowAlternationEnabled: true,
                showBorders: false,
                showColumnLines: false,
                showColumnHeaders: true,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: false,
                selection: {
                    allowSelectAll: false,
                    mode: "single"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 200,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,

                columns: [
                    { dataField: "accountNumber", caption: "Account Number", width: 120 },
                    { dataField: "accountName", caption: "Account Name", width: 200 },
                    { dataField: "advisorNames", caption: "Advisor", width: 150 },
                    { dataField: "aoBillingStyle", caption: "AO Billing Style", width: 150 },
                    { dataField: "orionBillingStyle", caption: "Orion Billing Style", width: 150 }
                ]
            };
        }

        loadDgData() {
            let rez: any;
            this.isInitializing = true;
            this.issuesCount = 0;

            if (this.advisoryFirmId && this.advisoryFirmId > 0) {
                rez = this.servicerService.getBillingStyleMonitorData(this.advisoryFirmId);
            }

            rez.then(response => {
                this.dgData = response.data;
                if (this.dgData.length > 0) {
                    this.issuesCount = this.dgData.length;
                }
                this.isInitializing = false;
            }, err => this.isInitializing = false)
            .catch(err => {
                this.generalService.showError(err);
            });
        };

        firmChanged(): void {
            this.advisoryFirmId = this.selFirm.id;
            this.loadDgData();
        }

        $onInit(): void {
            this.advisoryFirmApi.getAdvisoryFirmsLight().then(response => {
                this.advisoryFirms = response.data;
                this.selFirm = this.advisoryFirms[0];
                this.firmChanged();
            }).catch(reason => {
            });
        }
    }


    class BillingStyleMonitor implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                advisoryFirmId: "<",
                pageLen: "<",
                issuesCount: "="
            };
            this.controller = BillingStyleMonitorController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/servicer-module/components/billing-style-monitor.html";
        }
    }
    angular.module(Constants.APP).component("billingStyleMonitor", new BillingStyleMonitor());

}
